import Vue from "vue";
import {
  Button,
  Cell,
  CellGroup,
  Icon,
  Row,
  Col,
  Popup,
  Field,
  Tab,
  Tabs,
  Picker,
  ActionSheet,
  Dialog,
  Toast,
  Checkbox,
  CheckboxGroup,
  List,
  NoticeBar
} from "vant";
import "@vant/touch-emulator";

// 基础组件
Vue.use(Button)
  .use(Cell)
  .use(CellGroup)
  .use(Icon)
  .use(Row)
  .use(Col)
  .use(Popup)
  .use(ActionSheet)
  .use(Picker)
  .use(List)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Dialog)
  .use(NoticeBar);

// 表单组件
Vue.use(Field);

// 导航组件
Vue.use(Tab).use(Tabs);
//全局
Vue.prototype.$Dialog = Dialog;
Vue.prototype.$Toast = Toast;
